module.exports = __webpack_public_path__ + "media/svg/logo_02-7495fc7e.svg";